const SCRIPT_SRC = "https://api.reftagger.com/v2/RefTagger.js";

const settingsFor = (theme) => ({
  bibleVersion: "KJV",
  bibleReader: "biblia",
  tooltipStyle: theme === "dark" ? "dark" : "light",
  roundCorners: true,
  dropShadow: true,
  linksOpenNewWindow: true,
  useTooltip: true,
  tagChapters: true,
  addLogosLink: false,
  socialSharing: [],
  noSearchClassNames: ["no-reftag"],
  noSearchTagNames: ["h1", "h2", "h3", "nav", "header", "footer", "button", "input", "textarea", "select", "option"],
  customStyle: {
    heading: {
      backgroundColor: theme === "dark" ? "#c96a4f" : "#8d3a26",
      color: "#fffaf1",
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: "1.05em",
    },
    body: {
      color: theme === "dark" ? "#f1ebe0" : "#2a2420",
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: "1.05em",
      moreLink: { color: theme === "dark" ? "#e0a53d" : "#c58a1f" },
    },
  },
});

export function loadRefTagger(theme) {
  window.refTagger = { ...(window.refTagger || {}), settings: settingsFor(theme) };
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
  const s = document.createElement("script");
  s.src = SCRIPT_SRC;
  s.async = true;
  document.body.appendChild(s);
}

export function updateRefTaggerTheme(theme) {
  if (!window.refTagger) return;
  window.refTagger.settings = { ...window.refTagger.settings, ...settingsFor(theme) };
  retag();
}

let pending = null;
export function retag() {
  if (pending) cancelAnimationFrame(pending);
  pending = requestAnimationFrame(() => {
    pending = null;
    if (typeof window.refTagger?.tag === "function") window.refTagger.tag();
  });
}
